/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown>, suffix: NonNullable<unknown> }} Orders_No_Orders_MovedInputs */

const en_orders_no_orders_moved = /** @type {(inputs: Orders_No_Orders_MovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No orders moved to ${i?.status}${i?.suffix}.`)
};

const es_orders_no_orders_moved = /** @type {(inputs: Orders_No_Orders_MovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se movieron pedidos a ${i?.status}${i?.suffix}.`)
};

/**
* | output |
* | --- |
* | "No orders moved to {status}{suffix}." |
*
* @param {Orders_No_Orders_MovedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_no_orders_moved = /** @type {((inputs: Orders_No_Orders_MovedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_No_Orders_MovedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_no_orders_moved(inputs)
	return es_orders_no_orders_moved(inputs)
});